import React, { useState } from 'react';
import { FaTimes, FaPhoneAlt, FaWhatsapp, FaEnvelope } from 'react-icons/fa';
import './Contact.css';

const Contato = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showBubble, setShowBubble] = useState(true);

  const handleRedirect = (type) => {
    switch (type) {
      case 'call':
        window.location.href = 'tel:+244972614886';
        break;
      case 'whatsapp':
        window.open('https://wa.me/244972614886', '_blank');
        break;
      case 'email':
        window.location.href = 'mailto:geral@nwayami.com';
        break;
      default:
        break;
    }
  };

  return (
    <div className="chat-launcher">
      {/* Balão "Converse connosco" com botão X */}
      {showBubble && (
        <div className="chat-bubble">
          <div className="chat-header">
            <span>Converse connosco</span>
            <button className="close-bubble" onClick={() => setShowBubble(false)}>
              <FaTimes />
            </button>
          </div>
        </div>
      )}

      {/* Caixa de opções */}
      {isOpen && (
        <div className="contact-box">
          <div className="contact-header">
            <p>Olá! Eu sou o assistente virtual da <strong>N.WAYAMI</strong>.<br />Como posso ajudar?</p>
            <button className="close-contact" onClick={() => setIsOpen(false)}>
              <FaTimes />
            </button>
          </div>

          <div className="contact-options">
            <button style={{ backgroundColor: '#ff5722' }} onClick={() => handleRedirect('call')}>
              <FaPhoneAlt /> Ligar agora
            </button>
            <button style={{ backgroundColor: '#ff5722' }} onClick={() => handleRedirect('whatsapp')}>
              <FaWhatsapp /> Ligar no WhatsApp
            </button>
            <button style={{ backgroundColor: '#ff5722' }} onClick={() => handleRedirect('email')}>
              <FaEnvelope /> Enviar um e-mail
            </button>
          </div>
        </div>
      )}

      {/* Botão WhatsApp flutuante */}
      <div
        className="chat-whatsapp"
        onClick={() => setIsOpen(!isOpen)}
        title="Abrir opções"
      >
        <img
          src="https://img.icons8.com/color/48/000000/whatsapp--v1.png"
          alt="WhatsApp"
        />
      </div>
    </div>
  );
};

export default Contato;
